'use strict';

module.exports = {
  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipePropagation: true,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
  theme: 'default'
};



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/0/kpmg/novacci.kpmg.cz/~/perfect-scrollbar/src/js/plugin/default-setting.js
// module id = 99
// module chunks = 0